import { TOTP } from 'otpauth'

export function generateTotpCode(secret, { digits = 6, period = 30, algorithm = 'SHA1' } = {}) {
  try {
    const totp = new TOTP({
      secret: secret,
      digits: digits,
      period: period,
      algorithm: algorithm
    })
    return totp.generate()
  } catch (e) {
    console.error('TOTP generation error:', e)
    return '------'
  }
}

export function getRemainingSeconds(period = 30) {
  return period - (Math.floor(Date.now() / 1000) % period)
}
